import {Component, Input, OnInit, EventEmitter, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {TextEditorService} from '../shared/services/text-editor.service';

@Component({
  selector: 'app-edit-cultural-initiative-team',
  templateUrl: './edit-cultural-initiative-team.component.html',
  styleUrls: ['./edit-cultural-initiative-team.component.css']
})
export class EditCulturalInitiativeTeamComponent implements OnInit {
  @Input() content: string;
  @Output() newItemEvent = new EventEmitter<string>();
  editorConfig;

  constructor(
    private textEditorService: TextEditorService,
  ) {
  }

  ngOnInit(): void {
    this.editorConfig = this.textEditorService.editorConfig;
  }

  contentChanged(): void {
    this.newItemEvent.emit(this.content);
  }

}
